/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Data_History_TitleInputs */

const en_user_data_history_title = /** @type {(inputs: User_Data_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User data change history`)
};

const de_user_data_history_title = /** @type {(inputs: User_Data_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungsverlauf Nutzerdaten`)
};

/**
* | output |
* | --- |
* | "User data change history" |
*
* @param {User_Data_History_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const user_data_history_title = /** @type {((inputs?: User_Data_History_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Data_History_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_user_data_history_title(inputs)
	return en_user_data_history_title(inputs)
});